/**
 * Breakpoints da loja Green Rest (pixels).
 *
 * Fonte visual única dos nomes e faixas: assets/gr-responsive.css (`:root`, comentário inicial).
 * Use em `matchMedia(\`...\`)` para não divergir dos `@media` dos ficheiros CSS.
 *
 * Nota: em CSS, `@media` não pode usar `var(--gr-bp-*)`; lá mantêm-se os mesmos valores em px literal.
 */
window.GR_BREAKPOINTS = {
  MOBILE_SMALL_MAX: 319,
  MOBILE_NARROW_MAX: 577,
  MOBILE_TABLET_MAX: 767,
  TABLET_MAX: 991,
  DESKTOP_SMALL_MAX: 1199,
  TABLET_MIN: 768,
  DESKTOP_SMALL_MIN: 992,
  DESKTOP_LARGE_MIN: 1200,
};

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
